// Trust-tech blue design system — the PUBLIC/marketing site theme (default URL).
// The logged-in customer area uses a separate GREEN theme (see customerTheme.js),
// applied via a nested ConfigProvider in App.js. Keep in sync with tailwind.config.js.
const BRAND = '#0363d9';
const INK = '#08152b';

const fontStack =
  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

const theme = {
  token: {
    colorPrimary: BRAND,
    colorLink: BRAND,
    colorLinkHover: '#0799f7',
    colorSuccess: '#16a34a',
    colorWarning: '#fe9c07',
    colorError: '#ef4444',
    colorInfo: BRAND,
    colorBgLayout: '#f6f9fe',
    colorTextBase: INK,
    colorTextSecondary: '#64748b',
    borderRadius: 10,
    wireframe: false,
    fontFamily: fontStack,
    fontSize: 14,
    controlHeight: 40,
  },
  components: {
    Button: {
      borderRadius: 10,
      controlHeight: 42,
      fontWeight: 600,
      primaryShadow: '0 6px 16px -6px rgba(3, 99, 217, 0.5)',
    },
    Input: {
      borderRadius: 10,
      controlHeight: 42,
    },
    Select: {
      borderRadius: 10,
      controlHeight: 42,
    },
    Card: {
      borderRadiusLG: 16,
    },
    Menu: {
      itemColor: '#475569',
      itemSelectedColor: BRAND,
      itemHoverColor: BRAND,
      horizontalItemSelectedColor: BRAND,
      fontWeight: 500,
    },
    Typography: {
      fontFamily: fontStack,
    },
  },
};

export default theme;
